<template>
  <div>
    <div class="exerciseBox box" :name="fullExercise.identifier" v-bind:class="[startToggle, {'box-success': correctExercise}, {'box-danger': isIncorrect && !hasEssayQuestion}]">
      <div class="box-header with-border">
        <h3 v-if="!examExercise" class="box-title">{{ $options.filters.pickTranslation(fullExercise.title) || $t("pages.exercise.name") + " " + (examResults ? fullExercise.id : fullExercise.identifier) }}
          <a v-if="!examExercise" @click.prevent="showInfoModal(fullExercise)"><i class="fa fa-info-circle"></i></a>
        </h3>
        <h3 class="box-title" v-else>
          {{$t("pages.exercise.name") + " " +(index+1) + (exercisesNumber ? " / " + exercisesNumber : "")}}
        </h3>
        <div class="box-tools pull-right">
          <span v-if="subgroupExercise && subgroupExercise.exercise && subgroupExercise.exercise.currentRating" class="hidden-xs text-muted">
            {{$t("pages.exercise.rating")}}: {{subgroupExercise.exercise.currentRating}}
          </span>
          <span v-else-if="examResults" class="hidden-xs text-muted">
            {{$t("pages.exercise.rating")}}: {{examExercise.rating}}
          </span>
          <button type="button" class="btn btn-box-tool" @click.prevent="showReportModal(fullExercise)"><i class="fa fa-exclamation-triangle"></i>
          </button>
          <div class="btn-group">
            <button type="button" class="btn btn-box-tool dropdown-toggle">
              <i v-if="correctExercise" class="fa fa-check" style="color: #00a65a"></i>
              <i v-else-if="isIncorrect && !hasEssayQuestion" class="fa fa-times text-red" style="color: #f56954"></i>
            </button>
          </div>
          <button v-if="startToggle" type="button" class="btn btn-box-tool" @click.prevent="toggleColapsedBox()"><i class="fa fa-plus"></i></button>
          <button v-else type="button" class="btn btn-box-tool" @click.prevent="toggleColapsedBox()"><i class="fa fa-minus"></i></button>
        </div>
      </div>
      <div class="box-body">
        <exercise :subgroupExercise="subgroupExercise" :examExercise="examExercise"></exercise>
      </div>
    </div>
	
    <!-- modals -->
    <div class="modal modal-danger fade" :name="fullExercise.exerciseVersionId" :id="modalReportKey" v-if="showReportModalBoolean">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.reports.report')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <textarea v-model="reportBody" class="form-control" rows="5" id="comment"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.reports.close')}}</button>
            <button type="button" class="btn btn-outline" data-dismiss="modal" @click.prevent="reportExercise">{{$t('pages.reports.save')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    
    <!-- report success alert -->
    <div class="modal modal-success fade" :name="fullExercise.exerciseVersionId" :id="alertReportSuccessfulKey" v-if="showSuccessReportModalBoolean">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{$t('pages.reports.reportSuccessful')}}</h4>
            <button type="button" class="btn btn-outline pull-right" data-dismiss="modal">{{$t('pages.reports.close')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- erase modal -->
    <div class="modal modal-danger fade" id="modal-erase">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.buttons.deleteP')}}</h4>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.reports.close')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- end new modal -->
    <!-- info modal-->
    <div class="modal modal-success fade" :id="modalInfoKey" v-if="showInfoModalBoolean">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exercise.info')}}</h4>
          </div>
          <div class="modal-body">
            <p>{{$t('pages.exercise.modalInfoId')}}: {{fullExercise.identifier}}</p>
            <p v-if="fullExercise.author">{{$t('pages.exercise.modalInfoAuthor')}}: {{fullExercise.author}}</p>
            <p v-if="adminView && fullExercise.tags">
              {{$t('pages.exercise.modalInfoTags')}}:
              <span v-for="tag in fullExercise.tags" class="label label-primary" style="margin-left: 3pt">{{tag}}</span>
            </p>
            <p v-if="adminView && fullExercise.source">
              {{$t('pages.exercise.modalInfoSource')}}: {{fullExercise.source}}
            </p>
            <p v-if="subgroupExercise && subgroupExercise.exercise && subgroupExercise.exercise.currentRating">
              {{$t("pages.exercise.rating")}}: {{subgroupExercise.exercise.currentRating}}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.reports.close')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>

// import Numeric from '@/components/exercises/Numeric.vue'
// import OldExerciseNavigation from '@/components/exercises/OldExerciseNavigation.vue'
// import Radio from '@/components/exercises/Radio.vue'
// import Multichoice from '@/components/exercises/Multichoice.vue'
import Exercise from '@/components/exercises/Exercise.vue'
// import Essay from '@/components/exercises/Essay.vue'
import BeginExercise from '@/components/exercises/ExerciseTitle.vue'
import Rest from './../../services/rest'
import { mapState } from 'vuex'
// import InfiniteLoading from 'vue-infinite-loading'
let crypto = require('crypto')

export default {
  name: 'problem',
  data () {
    return {
      reportBody: '',
      fullExercise: '',
      isVisible: false,
      lng: 'sl', // todo fix language,
      admin: false,
      exerciseId: null,
      subsetOfQuestions: [],
      showReportModalBoolean: false,
      showInfoModalBoolean: false,
      showSuccessReportModalBoolean: false,
      modalInfoKey: 'modal-info-' + this.getUniqueKey(),
      modalReportKey: 'modal-report' + this.getUniqueKey(),
      alertReportSuccessfulKey: 'modal-report-success' + this.getUniqueKey(),
      startToggle: '',
      isIncorrect: false
    }
  },
  props: ['subgroupExercise', 'examExercise', 'index', 'exercisesNumber'],
  components: {
    'beginExercise': BeginExercise,
    'exercise': Exercise
    // InfiniteLoading
  },
  computed: {
    hasEssayQuestion () {
      if (!this.subgroupExercise || !this.subgroupExercise.exercise || !this.subgroupExercise.exercise.version || !this.subgroupExercise.exercise.version.questions) {
        return false
      }
      let hasEssayQuestion = false
      for (let i = 0; i < this.subgroupExercise.exercise.version.questions.length; i++) {
        if (this.subgroupExercise.exercise.version.questions[i].type === 'essay') {
          hasEssayQuestion = true
        }
      }
      return hasEssayQuestion
    },
    correctExercise () {
      if (this.subgroupExercise) {
        for (let i = 0; i < this.subgroupExercise.exercise.version.questions.length; i++) {
          if (!('correct' in this.subgroupExercise.exercise.version.questions[i])) {
            return false
          }
        }
        return true
      } else {
        return false
      }
    },
    ...mapState({
      trigger: state => state.exercises.incorrectTrigger
    }),
    examResults () {
      return this.$route.name === 'classExamResults' || this.$route.name === 'classExamResultsAdmin'
    },
    adminView () {
      return this.$route.meta.admin === true
    }
  },
  methods: {
    getUniqueKey () { // async?
      let generated = crypto.randomBytes(20).toString('hex')
      return generated
    },
/*     infiniteHandler ($state) {
      setTimeout(() => {
        const temp = []
        for (let i = this.subsetOfQuestions.length; i <= this.exerciseVersion.questions.length; i++) {
          if (this.exerciseVersion.questions[i]) temp.push(this.exerciseVersion.questions[i])
        }
        this.subsetOfQuestions = this.subsetOfQuestions.concat(temp)
        console.log('hej', this.subsetOfQuestions)
        $state.loaded()
      }, 1000)
    }, */
    toggleColapsedBox () {
      if (this.startToggle) {
        this.startToggle = ''
      } else {
        this.startToggle = 'collapsed-box'
      }
    },
    showInfoModal () {
      return new Promise((resolve, reject) => {
        console.log(this.trigger)
        this.showInfoModalBoolean = true
        resolve()
      }).then(() => {
        window.jQuery(`#${this.modalInfoKey}`).modal()
      })
    },
    showReportModal (fullExercise) {
      return new Promise((resolve, reject) => {
        this.showReportModalBoolean = true
        console.log(fullExercise)
        this.exerciseId = fullExercise.exerciseVersionId
        resolve()
      }).then(() => {
        console.log('its here', this.exerciseId)
        window.jQuery(`#${this.modalReportKey}`).modal()
      })
    },
    showSuccessfulReportAlert () {
      return new Promise((resolve, reject) => {
        this.showSuccessReportModalBoolean = true
        resolve()
      }).then(() => {
        window.jQuery(`#${this.alertReportSuccessfulKey}`).modal()
      })
    },
    reportExercise () { // report exercise
      let idExer = this.subgroupExercise.exercise.id
      console.log('report exercise ', idExer)
      let reportMsg = this.reportBody
      if (reportMsg === null || reportMsg === '') {
        return
      }
      // this.showSuccessfulReportModal()
      // rest request to report exercise
      this.showSuccessfulReportAlert()
      var postdata = {
        exerciseId: idExer,
        description: reportMsg
      }
      return Rest.request('POST', '/exerciseReports', postdata).then((data) => {
      }).catch((err) => {
        console.log(err)
      })
    },
    init () {
      if (this.subgroupExercise) this.fullExercise = this.subgroupExercise.exercise.version
      if (!window.jQuery.isEmptyObject(this.examExercise)) {
        this.fullExercise = this.examExercise
      }
      this.$store.commit('updateQuestionObject', {key: 'lngs', value: this.fullExercise.lngs})
      this.$nextTick(() => {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
      })
    }
  },
  mounted () {
    this.init()
    if (this.correctExercise) {
      this.startToggle = 'collapsed-box'
    }
  },
  watch: {
    $route () {
      this.init()
    },
    correctExercise () {
      let $ = window.jQuery
      $('div[name="' + this.fullExercise.identifier + '"]').toggleBox()
    },
    trigger () {
      if (this.subgroupExercise) {
        if (this.trigger.exerciseId === this.subgroupExercise.exercise.version.exerciseVersionId) {
          if (this.trigger.correct === true) {
            this.isIncorrect = false
          } else {
            this.isIncorrect = true
          }
        }
      }
    }
  }
}

</script>

<style>

.center {
    margin: auto;
    width: 50%;
    padding: 10px;
}
.gumb {
   border: none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 10px;
  color: #ffffff;
  font-size: 11px;
  background: gray;
  padding: 10px 20px 10px 20px;
  text-decoration: none;
}
.focused {
  background-color: green;
}
.wrong {
  background-color: red;
  border: 1px solid #f44336;
}
#comment {
  resize: none;
}
#reportExercise:hover {
  cursor: pointer;
}
.skrij {
  list-style: none;
}

a.first::after {
  content:' ...'
}

a.last::before {
  content:'... '
}

.current {
  color: red;
}
.exerciseBox .box-header {
  background-color: #f5f5f5;
  height: 100%;
}


/* .pagination .active a {
    background-color: #5cb85c;
    border-color: #dddddd;
    cursor: default;
} */


</style>



// WEBPACK FOOTER //
// Exercises.vue?2889c414